import {ActionEnum} from "../action.enum";
import {ServiceProviderModel} from "../../models/service_provider/service-provider.model";

export namespace ServiceProviderDialogAction {

  export class Create {
    static readonly type: ActionEnum = ActionEnum.SERVICE_PROVIDER_DIALOG_CREATE;
  }

  export class UpdateState {
    static readonly type: ActionEnum = ActionEnum.SERVICE_PROVIDER_DIALOG_UPDATE_STATE;

    constructor(public serviceProvider: ServiceProviderModel) {}
  }

  export class Save {
    static readonly type: ActionEnum = ActionEnum.SERVICE_PROVIDER_DIALOG_SAVE;
  }

  export class Delete {
    static readonly type: ActionEnum = ActionEnum.SERVICE_PROVIDER_DIALOG_DELETE;
  }

  export class Close {
    static readonly type: ActionEnum = ActionEnum.SERVICE_PROVIDER_DIALOG_CLOSE;
  }

  export class Reset {
    static readonly type: ActionEnum = ActionEnum.SERVICE_PROVIDER_DIALOG_RESET;
  }
}
